var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51883",
    "data-name": "Group 51883",
    transform: "translate(-458 -215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18589",
    "data-name": "Rectangle 18589",
    transform: "translate(458 215)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-donate-3831743",
    transform: "translate(456.002 213.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51881",
    "data-name": "Group 51881",
    transform: "translate(2.999 3.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47720",
    "data-name": "Path 47720",
    d: "M17.829,3.73a7.278,7.278,0,0,0-3.763,1.081A7.316,7.316,0,0,0,3,11a7.125,7.125,0,0,0,2.154,5.108l8.309,8.283a.851.851,0,0,0,1.2,0l8.3-8.24h0l.068-.068C27.576,11.621,24.18,3.645,17.829,3.73Zm.366,11.3H14.918V18.3a.851.851,0,0,1-1.7,0V15.026H9.938a.851.851,0,0,1,0-1.7h3.277V10.046a.851.851,0,1,1,1.7,0v3.277H18.2a.851.851,0,0,1,0,1.7Z",
    transform: "translate(-2.999 -3.729)",
    fill: "#7f7f7f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.eac7909575651b0a415d4280b413d3ea.svg";
export { ForwardRef as ReactComponent };